import { queryOptions } from '@tanstack/react-query'

import { getSystemSettingsHandler } from '@/features/Admin/SystemSettings/server.ts'
import { validateSessionHandler } from '@/features/Auth/server.ts'

export const SYSTEM_SETTINGS_QUERY_KEY = ['system-settings'] as const
export const AUTHENTICATED_SESSION_QUERY_KEY = [
    'authenticated-session',
] as const

export function profileImageVersionQueryKey(userId: string | undefined) {
    return ['profile-image-version', userId] as const
}

export function systemSettingsQueryOptions() {
    return queryOptions({
        queryKey: SYSTEM_SETTINGS_QUERY_KEY,
        queryFn: async function () {
            return await getSystemSettingsHandler()
        },
    })
}

export function authenticatedSessionQueryOptions() {
    return queryOptions({
        queryKey: AUTHENTICATED_SESSION_QUERY_KEY,
        queryFn: async function () {
            return await validateSessionHandler()
        },
    })
}
